// extracted by mini-css-extract-plugin
export default {"container":"SimpleInput_container__oJVGh","note":"SimpleInput_note__yqMKg","warning":"SimpleInput_warning__WBtSh"};